import cdnApi from './api-cdn';

const pluginAPI = {
	install(Vue) {
		Vue.prototype.$cdnAPI = cdnApi;
	},
};

export default pluginAPI;
